import styled from 'styled-components'
import { parseDateToDDDD_D_de_MMMM, parseDateToDDDD_D_de_MMMM_HH } from '../../helpers/dateFormatters'
import { useActiveCourse } from '../../pages/course/hooks/useActiveCourse'
import { useTranslation } from 'react-i18next'
import { useUserCourses } from '../../hooks/queries/useUserCourses'

export const CourseNoStartedYet = () => {
    const { t } = useTranslation('widget')
    const { currentCourse } = useUserCourses()
    const { activeCourse } = useActiveCourse()

    const startDate = parseDateToDDDD_D_de_MMMM_HH(`${currentCourse?.start}`)
    const startDateWthHour = parseDateToDDDD_D_de_MMMM(`${currentCourse?.start}`)

    return (
        <NoStatedStyle className="column-center">
            <div>
                <h2 className="widget-title">{t('Your course has not started yet')}</h2>

                {!activeCourse?.asyncCourse ? (
                    <p className="widget-subtitle light">
                        {t('You will be able to enter the virtual meeting from {{ startDate }} hours.', { startDate })}
                    </p>
                ) : (
                    <>
                        <p className="widget-subtitle light">{t('You can start from {{ startDate }}.', { startDateWthHour })}</p>
                        <p className="widget-subtitle light">{t('Stay tuned for the communications you will receive by email.')}</p>
                    </>
                )}
            </div>
        </NoStatedStyle>
    )
}

const NoStatedStyle = styled.div`
    min-height: inherit;
    text-align: center;
    padding: 0 1em;

    .calendar-link {
        width: 90%;
        display: flex;
        align-items: center;
        gap: 1.5em;
        text-align: justify;
    }
`
